import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { MessageCircle, Copy, Home, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const WhatsAppConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [copied, setCopied] = useState(false);
  
  const { message } = location.state || {};

  const handleCopyMessage = () => {
    if (message) {
      navigator.clipboard.writeText(message).then(() => {
        setCopied(true);
        toast.success("Message copié dans le presse-papiers !");
        setTimeout(() => setCopied(false), 3000);
      }).catch(() => {
        toast.error("Erreur lors de la copie du message");
      });
    }
  };

  const handleOpenWhatsApp = () => {
    const whatsappUrl = `https://wa.me/33679393429?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <Card className="max-w-2xl w-full border-2 border-gray-200 shadow-xl backdrop-blur-sm bg-white/95">
        <CardHeader className="text-center bg-gradient-to-r from-green-50 to-emerald-50 border-b border-gray-200">
          <div className="mx-auto mb-4">
            <MessageCircle data-testid="whatsapp-icon" className="h-16 w-16 text-green-500" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">
            Réservation Créée avec Succès !
          </CardTitle>
          <CardDescription className="text-base">
            Votre demande de réservation a été enregistrée
          </CardDescription>
        </CardHeader>

        <CardContent className="p-6 sm:p-8 space-y-6">
          <div className="p-6 bg-green-50 rounded-xl border border-green-200">
            <h3 className="font-semibold text-lg text-gray-900 mb-3">
              Prochaine étape : Contactez-nous sur WhatsApp
            </h3>
            <p className="text-sm text-gray-700 mb-4">
              Pour finaliser votre réservation, veuillez nous envoyer les détails via WhatsApp au numéro :
            </p>
            <div className="flex items-center justify-center gap-2 p-3 bg-white rounded-lg border border-green-300">
              <MessageCircle className="h-5 w-5 text-green-600" />
              <span className="font-bold text-lg text-gray-900">+33 6 79 39 34 29</span>
            </div>
          </div>

          {message && (
            <div className="space-y-3">
              <h4 className="font-semibold text-gray-900">Votre message de réservation :</h4>
              <div className="p-4 bg-gray-50 rounded-lg border border-gray-200 max-h-64 overflow-y-auto">
                <pre className="text-sm text-gray-700 whitespace-pre-wrap font-sans">
                  {message}
                </pre>
              </div>
              
              <div className="flex gap-3">
                <Button
                  data-testid="copy-message-btn"
                  onClick={handleCopyMessage}
                  variant="outline"
                  className="flex-1 border-2"
                >
                  {copied ? (
                    <>
                      <Check className="mr-2 h-4 w-4 text-green-600" />
                      Copié !
                    </>
                  ) : (
                    <>
                      <Copy className="mr-2 h-4 w-4" />
                      Copier le message
                    </>
                  )}
                </Button>
                
                <Button
                  data-testid="open-whatsapp-btn"
                  onClick={handleOpenWhatsApp}
                  className="flex-1 bg-green-500 hover:bg-green-600 text-white"
                >
                  <MessageCircle className="mr-2 h-4 w-4" />
                  Ouvrir WhatsApp
                </Button>
              </div>
            </div>
          )}

          <div className="pt-4 border-t border-gray-200">
            <p className="text-sm text-gray-600 mb-4 text-center">
              Nous vous répondrons dans les plus brefs délais pour confirmer votre réservation.
            </p>
            
            <Button
              data-testid="back-home-btn"
              onClick={() => navigate("/")}
              variant="outline"
              className="w-full border-2"
            >
              <Home className="mr-2 h-4 w-4" />
              Retour à l'accueil
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default WhatsAppConfirmation;
